"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RBITokenType = void 0;
var RBITokenType;
(function (RBITokenType) {
    RBITokenType["unverified"] = "unverified";
    RBITokenType["verified"] = "verified";
})(RBITokenType || (exports.RBITokenType = RBITokenType = {}));
//# sourceMappingURL=auth.js.map